import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import CessationOverview from './CessationOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyCessationOverview } from './companyCessationApi';

/** Company Cessation → Overview. Scoping comes from the token and the toggle. */
const CCessationOverview = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyCessationOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Quit Programmes | Shoorah</title>
      </Helmet>
      <CessationOverview
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CCessationOverview;
